import React from 'react';
import { useIntl } from 'react-intl';
import { StepsIntl } from './Steps.intl';
import './Steps.scss';
import devicePhoto from '../../static/calibration/calibration-third-step.png';
import { TextField } from '@material-ui/core';
import { NumberFormatCustom } from './stepsHelper';
import { useField } from 'formik';
import { useBem } from '../../Bem';
import { useCurrentMeasurment, steps } from '../helper';

export const Step3 = () => {
  const bem = useBem('step3');
  const intl = useIntl();
  const [field, meta, helpers] = useField({ name: 'vehicleWidth' });
  const currentMeasurment = useCurrentMeasurment();

  return (
    <div className={bem.elem('container').cls()}>
      <p className={bem.elem('text').cls()}>
        <span>(3/{steps.length})&nbsp;</span>
        <span>{intl.formatMessage(StepsIntl.descriptionStep_3, { value: currentMeasurment.value.toLowerCase() })}</span>
      </p>
      <div className={bem.elem('text-field').cls()}>
        <TextField
          variant="standard"
          style={{width: 125 }}
          type="text"
          fullWidth={false}
          placeholder={`0 ${currentMeasurment.value.toLowerCase()}`}
          name="vehicleWidth"
          onChange={field.onChange}
          value={field.value}
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
          InputProps={{
            inputComponent: NumberFormatCustom as any,
          }}
        />
      </div>
      <div className={bem.elem('wrapper').cls()}>
        <img className={bem.elem('photo').mods('step3').cls()} src={devicePhoto} />
      </div>
    </div>
  );
};
